import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { CAMPAIGN_SEND_FOR_APPROVAL, CAMPAIGN_SEND_FOR_APPROVAL_SUCCESS, CAMPAIGN_SEND_FOR_APPROVAL_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* campaignSendForApproval({ payload }) {
  console.log('CAMPAIGN_SEND_FOR_APPROVAL payload:', payload);
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { approval_id } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/campaigns/send-for-approval`,
      method: 'POST',
      data: payload.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: CAMPAIGN_SEND_FOR_APPROVAL_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: CAMPAIGN_SEND_FOR_APPROVAL_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CAMPAIGN_SEND_FOR_APPROVAL_ERROR, payload: error });
  }
}

export function* watchCampaignSendForApproval() {
  yield takeEvery(CAMPAIGN_SEND_FOR_APPROVAL, campaignSendForApproval);
}

function* campaignSendForApprovalSaga() {
  yield all([fork(watchCampaignSendForApproval)]);
}

export default campaignSendForApprovalSaga;
